import ActiveOptionViewState from '../../store/schema/ActiveOptionViewState';
import SignatureViewState from '../../store/schema/SignatureViewState';
import updateSignatureViewState from '../../actions/signature/updateSignatureViewState';
import { getOptionsStore } from '../../store/Store';
import { mutator } from 'satcheljs';

const updateSignatureViewStateMutator = mutator(
    updateSignatureViewState,
    (actionMessage: { changes: SignatureViewState }) => {
        const { changes } = actionMessage;
        if (changes && !!Object.keys(changes).length) {
            // it should also have keys present so that this mutator is not used for clearing the state
            const store = getOptionsStore();
            if (store && store.activeViewState) {
                // it should have a view state so that this is not used for initialisation
                const viewState: SignatureViewState = store.activeViewState as SignatureViewState;
                store.activeViewState = {
                    ...viewState,
                    ...changes,
                } as ActiveOptionViewState;
            }
        }
    }
);

// exported only for testing purposes
export default updateSignatureViewStateMutator;
